import { render, staticRenderFns } from "./BasicSet.vue?vue&type=template&id=87159360&scoped=true&"
import script from "./BasicSet.vue?vue&type=script&lang=js&"
export * from "./BasicSet.vue?vue&type=script&lang=js&"
import style0 from "./BasicSet.vue?vue&type=style&index=0&id=87159360&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87159360",
  null
  
)

export default component.exports